module.exports = __webpack_public_path__ + "static/media/ag.e367f007.svg";